let ultimoSomEm = 0;
const CHAVE_SOM_NOTIFICACOES = "i9:notificacoes-som";

export function definirSomNotificacoesAtivo(ativo: boolean) {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(CHAVE_SOM_NOTIFICACOES, ativo ? "1" : "0");
  }
}

function somNotificacoesAtivo() {
  return typeof window === "undefined" || window.localStorage.getItem(CHAVE_SOM_NOTIFICACOES) !== "0";
}

type JanelaComWebkitAudio = Window & typeof globalThis & {
  webkitAudioContext?: typeof AudioContext;
};

export function tocarSomNovaMensagem() {
  if (!somNotificacoesAtivo() || typeof window === "undefined" || Date.now() - ultimoSomEm < 1_000) return;

  const ConstrutorAudio = window.AudioContext
    || (window as JanelaComWebkitAudio).webkitAudioContext;
  if (!ConstrutorAudio) return;

  ultimoSomEm = Date.now();
  const contexto = new ConstrutorAudio();
  const tocar = () => {
    const inicio = contexto.currentTime;
    const oscilador = contexto.createOscillator();
    const volume = contexto.createGain();

    oscilador.type = "sine";
    oscilador.frequency.setValueAtTime(720, inicio);
    oscilador.frequency.exponentialRampToValueAtTime(960, inicio + 0.14);
    volume.gain.setValueAtTime(0.0001, inicio);
    volume.gain.exponentialRampToValueAtTime(0.16, inicio + 0.02);
    volume.gain.exponentialRampToValueAtTime(0.0001, inicio + 0.24);
    oscilador.connect(volume);
    volume.connect(contexto.destination);
    oscilador.start(inicio);
    oscilador.stop(inicio + 0.25);
    oscilador.addEventListener("ended", () => void contexto.close(), { once: true });
  };

  if (contexto.state === "suspended") {
    void contexto.resume().then(tocar).catch(() => void contexto.close());
  } else {
    tocar();
  }
}
